import { createRouter, useNavigate } from '@tanstack/react-router';

import { NotFound } from '@nesso/ui/blocks/not-found';

import { routeTree } from './route-tree.gen';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <NotFound actionLabel="Go to Sign In" onAction={() => void navigate({ to: '/login' })} />
    );
}

export const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    defaultNotFoundComponent: NotFoundPage,
});

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
